import React from "react"
import { Skeleton } from "@material-ui/lab"
import {
	Grid,
	makeStyles
} from "@material-ui/core"

import { Portlet } from "@/components"

const useStyles = makeStyles({
	container: {
		minHeight: 70
	}
})

const ChatBotListSkeleton = () => {
	const classes = useStyles()

	const exampleArray = Array.from(Array(2).keys())

	return (
		<Grid
			container
			direction="column"
			spacing={5}
		>
			<Grid item xs={12}>
				<Grid container direction="column" spacing={1}>
					<Grid item>
						<Skeleton variant="text" width="30%" height={40} />
					</Grid>
					<Grid item>
						<Skeleton variant="text" width="40%" height={40} />
					</Grid>
				</Grid>
			</Grid>

			<Grid item xs={12}>
				<Grid container direction="column">
					{
						exampleArray.map((_, idx) => (
							<Grid item xs={12} key={idx}>
								<Portlet
									elevation={1}
								>
									<Grid
										container
										alignItems="center"
										justifyContent="space-between"
										className={classes.container}
										wrap="nowrap"
										spacing={3}
									>
										<Grid item xs={12} sm={2} md={1}>
											<Skeleton variant="rect" width="100%" height={40} style={{ maxWidth: 40 }} />
										</Grid>

										<Grid item xs={12} sm={6} md={3}>
											<Skeleton variant="text" width="100%" height={40} style={{ maxWidth: 200 }} />
										</Grid>

										<Grid item xs={2}>
											<Skeleton variant="rect" width="100%" height={30} style={{ maxWidth: 100 }} />
										</Grid>

										<Grid item xs={4}>
											<Skeleton variant="text" width="100%" height={40} style={{ maxWidth: 300 }} />
										</Grid>

										<Grid item xs={12} sm={12} md>
											<Grid container spacing={1} justifyContent="flex-end">
												<Grid item xs={6} sm={5}>
													<Skeleton variant="rect" width="100%" height={40} style={{ maxWidth: 64 }} />
												</Grid>

												<Grid item xs={6} sm={5}>
													<Skeleton variant="rect" width="100%" height={40} style={{ maxWidth: 64 }} />
												</Grid>
											</Grid>
										</Grid>
									</Grid>
								</Portlet>
							</Grid>
						))
					}
				</Grid>
			</Grid>
		</Grid>
	)
}

export default ChatBotListSkeleton
